/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_TimeInputs */

const vi_order_time = /** @type {(inputs: Order_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ`)
};

/**

* @param {Order_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_time = /** @type {((inputs?: Order_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_time(inputs)
});